import { HTMLAttributes } from 'react'

import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type SearchMode = 'free' | 'address' | 'area'

export type SearchSwitchProps = Omit<
  HTMLAttributes<HTMLDivElement>,
  'onChange'
> & {
  mode: SearchMode
  // eslint-disable-next-line no-unused-vars
  onChange: (mode: SearchMode) => void
  isMobile?: boolean
}

const SearchSwitch = ({
  mode,
  onChange,
  isMobile,
  className,
  ...props
}: SearchSwitchProps) => {
  const { strings } = useStore()

  const tabs: { mode: SearchMode; label: string; mobileHidden?: boolean }[] = [
    {
      mode: 'free',
      label: strings?.labels?.sales_network_free_search || 'Mappa',
      mobileHidden: true
    },
    {
      mode: 'address',
      label:
        strings?.labels?.sales_network_search_address || 'Ricerca per Indirizzo'
    },
    {
      mode: 'area',
      label: strings?.labels?.sales_network_search_area || 'Ricerca per Area'
    }
  ]

  const visibleTabs = isMobile ? tabs.filter((t) => !t.mobileHidden) : tabs

  return (
    <div
      role="tablist"
      aria-label={strings?.labels?.search_mode || 'Modalità di ricerca'}
      className={cn(
        'flex w-full items-center gap-spacing-2xs rounded-full border border-[rgba(255,255,255,.3)] p-spacing-2xs md:w-auto',
        className
      )}
      data-search-switch
      {...props}
    >
      {visibleTabs.map((tab) => (
        <button
          key={tab.mode}
          type="button"
          role="tab"
          aria-selected={mode === tab.mode}
          onClick={() => onChange(tab.mode)}
          className={cn(
            'flex h-full flex-1 items-center justify-center whitespace-nowrap rounded-full px-[16px] py-[8px] text-center transition-colors',
            mode === tab.mode
              ? 'pointer-events-none bg-[#F2F2F2] text-text-button-secondary-invert-dark'
              : 'text-white hover:bg-[rgba(255,255,255,.1)]'
          )}
        >
          <Typography variant="small" component="span" className="condensed">
            {tab.label}
          </Typography>
        </button>
      ))}
    </div>
  )
}

export default SearchSwitch
